<template>
  <div class="page">
    <div style="background-color: lightgrey">
      <van-collapse v-model="activeNames">
        <van-collapse-item name="1" title="查询条件">
          <van-field v-model="queryFormModel.id" :colon="true" label="ID" placeholder="请输入ID" type="digit"/>
          <van-field v-model="queryFormModel.name" :colon="true" label="名称" placeholder="请输入名称"/>
          <van-field
              :colon="true"
              :value="queryFormModel.sex"
              clickable
              label="性别"
              placeholder="请选择性别"
              readonly
              @click="openPicker(sexColumn,(value)=>{queryFormModel.sex = value})"
          />
          <van-field
              :colon="true"
              :value="queryFormModel.isDisabled"
              clickable
              label="上架状态"
              placeholder="请选择上架状态"
              readonly
              @click="openPicker(isDisabledColumn,(value)=>{queryFormModel.isDisabled = value})"
          />
          <van-cell title="开始时间" :value="queryFormModel.startTime" is-link  @click="showDatetimePickerPopup('start')" style="background: #fff;" />
          <van-cell title="结束时间" :value="queryFormModel.endTime" is-link  @click="showDatetimePickerPopup('end')" style="background: #fff;" />
          <div class="flex justify-center margin-tb-xs">
            <van-button size="large" type="info" @click="loadData(true)">查询</van-button>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>

    <van-list
            v-model="loading"
            :finished="listFinished"
            finished-text="没有更多了"
            @load="loadData">
      <div class="overflow-slide">
        <table v-if="isCustomColumns" class="table" width="100%" bgcolor="#fff" style="margin-top: 8px;text-align: center;" >
          <tr>
            <th style="background: var(--primary-color)">店员</th>
            <th>等级</th>
            <th>在线时长</th>
            <th v-for="(item,index) in tableColumns" :key="index">{{item.title}}</th>
          </tr>
          <tr v-for="(item, index) in list" :key="index">
            <td>{{item.name}}</td>
            <td>{{$store.state.ClerkGradeMap[item.grade]}}</td>
            <td>{{formatTime(item.onLineDuration)}}</td>
            <td v-for="(column,index) in tableColumns" :key="index">{{item[column.key]}}</td>
          </tr>
        </table>
        <table v-if="!isCustomColumns" class="table" width="100%" bgcolor="#fff" style="margin-top: 8px;text-align: center;">
          <tr>
            <th style="background: var(--primary-color)">店员</th>
<!--            <th>组名</th>-->
            <th>等级</th>
            <th>订单数</th>
            <th>首单数</th>
            <th>续单数</th>
            <th>退款单数</th>
            <th>接单超时数</th>
            <th>接单超时扣除金额</th>
            <th>订单金额</th>
            <th>首单金额</th>
            <th>续单金额</th>
            <th>打赏金额</th>
            <th>退款金额</th>
            <th>用户数</th>
            <th>续单用户数</th>
            <th>续单率</th>
            <th>续费率</th>
            <th>退单率</th>
            <th>续客率</th>
            <th>客单价</th>
            <th v-if="$hasFeature('out_order')">外部订单数</th>
            <th v-if="$hasFeature('out_order')">外部订单总额</th>
            <th v-if="$hasFeature('out_order')">外部订单工资</th>
            <th>工资</th>
            <th>在线时长</th>
          </tr>
          <tr v-for="(item, index) in list" :key="index">
            <td>{{item.name}}</td>
<!--            <td>{{item.groupName}}</td>-->
            <td>{{$store.state.ClerkGradeMap[item.grade]}}</td>
            <td>{{item.orderCount}}</td>
            <td>{{item.firstCount}}</td>
            <td>{{item.continuedCount}}</td>
            <td>{{item.refundedCount}}</td>
            <td>{{item.confirmTimeoutOrderCount}}</td>
            <td><small>¥ </small>{{formatPrice(item.deductWages)}}</td>
            <td><small>¥ </small>{{formatPrice(item.orderAmount)}}</td>
            <td><small>¥ </small>{{formatPrice(item.firstAmount)}}</td>
            <td><small>¥ </small>{{formatPrice(item.continuedAmount)}}</td>
            <td><small>¥ </small>{{formatPrice(item.rewardAmount)}}</td>
            <td><small>¥ </small>{{formatPrice(item.refundedAmount)}}</td>
            <td>{{item.userCount}}</td>
            <td>{{item.continuedUserCount}}</td>
            <td>{{calContinuedPercent(item.orderCount, item.continuedCount)}}%</td>
            <td>{{calContinuedFeePercent(item.orderAmount, item.continuedAmount)}}%</td>
            <td>{{refundPercent(item.refundedCount,item.totalOrderCount)}}%</td>
            <td>{{continueUserPercent(item.continuedUserCount,item.userCount)}}%</td>
            <td><small>¥ </small>{{userPricePercent(item.orderAmount,item.userCount)}}</td>
            <td v-if="$hasFeature('out_order')">{{item.outOrderCount}}</td>
            <td v-if="$hasFeature('out_order')"><small>¥ </small>{{formatPrice(item.outOrderTotalAmount)}}</td>
            <td v-if="$hasFeature('out_order')"><small>¥ </small>{{formatPrice(item.outOrderClerkWages)}}</td>
            <td><small>¥ </small>{{formatPrice(item.clerkWagesAmount)}}</td>
            <td>{{formatTime(item.onLineDuration)}}</td>
          </tr>
        </table>
      </div>
    </van-list>

    <van-popup v-model="picker.show" position="bottom" round>
      <van-picker
          :columns="picker.columns"
          show-toolbar
          @cancel="onPickerCancel"
          @confirm="onPickerConfirm"
      />
    </van-popup>
    <!-- 选择日期 -->
    <van-popup
            v-model="datetimePickerPopupShow"
             class="datetime-picker-popup"
             position="bottom"
    >
      <van-datetime-picker
              v-model="datetimePicker.value"
              type="date"
              :max-date="datetimePicker.maxDate"
              :formatter="datetimePickerFormatter"
              @confirm="datetimePickerConfirm"
              @cancel="datetimePickerPopupShow = false"
      />
    </van-popup>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {
    Popup,
    Button,
    List,
    CellGroup,
    Cell,
    Row,
    Col,
    DatetimePicker,
    ActionSheet,
    Dialog,
    Toast,
    Collapse, CollapseItem, Field, Picker
  } from 'vant';
  import { statisticsClerkOrder } from '@/api/guilder/order'
  import { getTable } from '@/api/custom_table'
  import moment from 'moment';
  import Decimal from 'decimal.js';
  import _ from "lodash";
  import {
    updateGroup,
    updateIsDisabled
  } from "@/api/clerk";

  Vue.use(Popup)
      .use(Button)
      .use(List)
      .use(CellGroup)
      .use(Cell)
      .use(Row)
      .use(Col)
      .use(DatetimePicker)
      .use(ActionSheet)
      .use(Dialog)
      .use(Toast)
      .use(Collapse)
      .use(CollapseItem)
      .use(Field)
      .use(Picker)

  export default {
    name: 'leader-clerk-wages',
    components: {
    },
    data () {
      return {
        activeNames: [1],
        queryFormModel: {
          id: null,
          name: null,
          sex: null,
          isDisabled: null,
          startTime: moment().subtract(1, 'weeks').format('YYYY-MM-DD'),
          endTime: moment().subtract(1, 'days').format('YYYY-MM-DD')
        },
        picker: {
          show: false,
          columns: [],
          onConfirm: null,
          onCancel: null
        },
        isDisabledMap: {
          '上架': false,
          '下架': true
        },
        datetimePickerPopupShow: false,
        datetimePicker: {
          field: null,
          value: null,
          maxDate: moment().add('3', 'month').toDate()
        },
        list: [],
        loading: true,
        listFinished: false,
        pageNo: 1,
        pageSize: 10,

        isCustomColumns:false,
        tableColumns:[],
      }
    },
    computed: {
      sexColumn() {
        return this.mapEnumToColumn(this.$store.state.ClerkSexEnum)
      },
      groupColumn() {
        return _.filter(this.$store.state.ClerkGroupMap, (elem) => {
          return elem !== '全部'
        })
      },
      isDisabledColumn() {
        return Object.keys(this.isDisabledMap)
      }
    },
    methods: {
      mapEnumToColumn(Enum) {
        return _.map(Enum.list(), (elem) => {
          return elem.label
        })
      },
      openPicker(columns, onConfirm,onCancel) {
        this.picker.columns = columns
        this.picker.onConfirm = onConfirm
        if(!onCancel){
          onCancel = () => {
            onConfirm(null)
          }
        }
        this.picker.onCancel = onCancel;
        this.picker.show = true
      },
      onPickerConfirm(value) {
        if (this.picker.onConfirm) {
          this.picker.onConfirm(value)
        }
        this.picker.show = false
      },
      onPickerCancel(value) {
        if (this.picker.onCancel) {
          this.picker.onCancel(value)
        }
        this.picker.show = false
      },
      datetimePickerFormatter(field, value) {
        if (field === 'year') {
          return `${value}年`;
        } else if (field === 'month') {
          return `${value}月`
        } else if (field == 'day') {
          return `${value}日`
        }
        return value;
      },
      showDatetimePickerPopup(field) {
        this.datetimePicker.field = field
        if (field == 'start') {
          this.datetimePicker.value = moment(this.queryFormModel.startTime).toDate()
        } else if (field == 'end') {
          this.datetimePicker.value = moment(this.queryFormModel.endTime).toDate()
        }
        this.datetimePickerPopupShow = true;
      },
      datetimePickerConfirm(value) {
        this.datetimePickerPopupShow = false;
        if (this.datetimePicker.field == 'start') {
          this.queryFormModel.startTime = moment(value).format('YYYY-MM-DD');
        } else if (this.datetimePicker.field == 'end') {
          this.queryFormModel.endTime = moment(value).format('YYYY-MM-DD');
        }
      },
      formatPrice(price) {
        if (price != null) {
          return Decimal.div(price, 100).toString()
        }
        return ''
      },
      formatTime(stamp){
        // 转换为时间段
        stamp = stamp / 1000
        let str = ''
        let d = stamp / 86400
        if (d >= 1) {
          str += Math.floor(d) + '天'
          stamp = stamp - 86400 * Math.floor(d)
        }
        let h = stamp / 3600
        if (h >= 1) {
          str += Math.floor(h) + '小时'
          stamp = stamp - 3600 * Math.floor(h)
        }
        let m = stamp / 60
        if (m >= 1) {
          str += Math.floor(m) + '分钟'
        }
        if (str == '') {
          return 0
        }
        return str
      },
      // 计算续单率
      calContinuedPercent(count, continuedCount) {
        let result = Decimal.mul(Decimal.div(continuedCount, count), 100).toFixed(2)
        return !isNaN(result) ? result : 0
      },
      calContinuedFeePercent(orderAmount, continuedFeeAmount) {
        let result = Decimal.mul(Decimal.div(continuedFeeAmount, orderAmount), 100).toFixed(2)
        return !isNaN(result) ? result : 0
      },
      refundPercent(refundedCount, totalOrderCount) {
        let result = Decimal.mul(Decimal.div(refundedCount, totalOrderCount), 100).toFixed(2)
        return !isNaN(result) ? result : 0
      },
      continueUserPercent(continuedUserCount, userCount) {
        let result = Decimal.mul(Decimal.div(continuedUserCount, userCount), 100).toFixed(2)
        return !isNaN(result) ? result : 0
      },
      userPricePercent(orderAmount, userCount) {
        let result = Decimal.div(Decimal.div(orderAmount, userCount), 100).toFixed(2)
        return !isNaN(result) ? result : 0
      },
      getTable(){
        getTable('statistics-clerk-order').then((res) => {
          const data = res.data
          if (data.code == 0) {
            let tableColumns = data.tableColumns
            if (tableColumns != null && tableColumns.length != 0){
              this.tableColumns=tableColumns
              this.isCustomColumns=true;
              return
            }else {
              this.isCustomColumns=false;
              return
            }
          }
        })
      },
      loadData(resetFirstPage) {
        this.activeNames = []
        // 重置为首页
        if (resetFirstPage) {
          this.pageNo = 1
        }
        // 清空数据
        if (this.pageNo == 1) {
          this.list = [];
        }
        this.loading = true
        let {
          id,
          name,
          sex,
          isDisabled,
        } = this.queryFormModel
        if (sex) {
          sex = this._.find(this.$store.state.ClerkSexEnum.list(), (elem) => {
            return elem.label === sex
          }).value;
        }
        if (isDisabled != null) {
          isDisabled = this.isDisabledMap[isDisabled]
        }
        statisticsClerkOrder(id, name, sex, isDisabled,
            this.queryFormModel.startTime,
            this.queryFormModel.endTime,
            this.pageNo,
            this.pageSize).then(res => {
          this.loading = false
          const data = res.data;
          if (data.code == 0) {
            this.list = this.list.concat(data.list)
            if (data.hasNextPage) {
              this.listFinished = false
            } else {
              this.listFinished = true
            }
          } else {
            this.listFinished = true
            Dialog.alert({
              title: '加载失败',
              message: data.msg
            })
          }
          this.pageNo ++
        })
      },
    },
    activated () {
      this.getTable()
    },
    mounted() {
      let updateMethodMap = new Map();
      updateMethodMap.set('isDisabled',updateIsDisabled)
      updateMethodMap.set('group',updateGroup)
      this.updateMethodMap = updateMethodMap;
      this.loadData(true)
    },
    updated() {
      // 统一替换标签
      this.$replaceLabel(document.body, this.$store.state.label, true)
    }
  }
</script>

<style lang="less" scoped>

  .page {

  }

  .table {
    border-collapse: separate;
    border-spacing:0;

    th, td {
      width: 100%;
      font-weight: normal;
      padding: 8px 5px;
      border-right: 1px solid #eee;
      border-bottom: 1px solid #eee;
      box-sizing: border-box;
    }
    th {
      color: #fff;
      background: var(--primary-color);
    }
    td {
      color: #666;
    }

    td:first-child, th:first-child {
      position:sticky;
      left:0; /* 首行在左 */
      z-index:10;
      background-color: #FFFFFF;
      -webkit-box-shadow:1px 2px 6px 0px #e9e9e9;
      border-right: 0px;
    }

    th:first-child{
      z-index:2;
    }
  }

  .overflow-slide{
    overflow-x: auto;
    white-space: nowrap;
    justify-content: space-evenly;
  }


</style>
